import type { TrashItem } from '@/services/project/trash';
import { create } from 'zustand';

interface TrashStore {
  list: TrashItem[];
  hasNextPage: boolean;
  initialized: boolean;
  hasTrashData: boolean | null;
  setList: (list: TrashItem[]) => void;
  appendList: (list: TrashItem[]) => void;
  setHasNextPage: (hasNextPage: boolean) => void;
  setInitialized: (initialized: boolean) => void;
  setHasTrashData: (hasTrashData: boolean) => void;
  reset: () => void;
}

const initialState = {
  list: [] as TrashItem[],
  hasNextPage: true,
  initialized: false,
  hasTrashData: null as boolean | null,
};

export const useTrashStore = create<TrashStore>(set => ({
  ...initialState,
  setList: list => set({ list, hasTrashData: list.length > 0, initialized: true }),
  appendList: list => set(state => {
    const nextList = [...state.list, ...list];
    return {
      list: nextList,
      hasTrashData: nextList.length > 0,
      initialized: true,
    };
  }),
  setHasNextPage: hasNextPage => set({ hasNextPage }),
  setInitialized: initialized => set({ initialized }),
  setHasTrashData: hasTrashData => set({ hasTrashData }),
  reset: () => set(initialState),
}));
